@let state = this.modalState();
@if (state) {
  <cam-layout-full-panel
    [toggleState]="state.open()"
    (closeEvent)="this.cancel()"
    [withSide]="true"
    [title]="'project.document-attachment-modal.title' | translate"
    type="modal"
    size="md"
  >
    <div panel-content>
      <cam-input-upload [input]="this.uploadInput" [standalone]="true"></cam-input-upload>
    </div>
  </cam-layout-full-panel>
}
